import _ from 'lodash'

const removeQuestionMaskFromObjKeys = obj => {
  if (Array.isArray(obj)) {
    return obj.map(v => removeQuestionMaskFromObjKeys(v))
  } else if (obj != null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [_.replace(key, '?', '')]: removeQuestionMaskFromObjKeys(obj[key])
      }),
      {}
    )
  }
  return obj
}

export default removeQuestionMaskFromObjKeys
